<template>
    <div class="modelConfig">
        <div class="modelConfig-wrap">
            <div class="modelConfig-nav">
                <!-- <a :href="hyuSite">Homepage</a> -->
                <router-link to="/" @click.native="resetNavSteps">Gama Hyundai</router-link>
                <p> {{ resumeData.model }} </p>
                <p v-if="setVersionCrump">{{ setVersionCrump }}</p>
                <p v-if="setExtCrump">{{ setExtCrump }}</p>
                <p v-if="setIntCrump">{{ setIntCrump }}</p>
            </div>
            <!-- <h2 class="modelConfig-title" v-html="secTitle"></h2> -->
            <div v-show="showLeftCol" class="modelConfig-left">
                <slot name="carLook"></slot>
            </div>
            <div v-show="showRigthCol" :class="'modelConfig-right '+ rigthColClass">
                <slot name="carOptions"></slot>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters, mapMutations, mapState } from 'vuex'

    export default {
        name: 'ModelConfig',
        components:{},
        props:{
            secTitle: {type: String, default: 'Selecione a opção do seu modelo'},
            // currModel: {type: String, default: 'Modelo'},
            showLeftCol: {type: Boolean, default: true},
            showRigthCol: {type: Boolean, default: true},
            rigthColClass: {type: String, default: ''},
        },
        computed:{
            ...mapState(['hyuSite', 'resumeData']),
            ...mapGetters({
                getVersion: 'versionsData/getVersionById',
            }),
            setVersionCrump(){
                let versionID =this.resumeData?.versionID
                if(versionID){
                    let version = this.getVersion(versionID)?.designation
                    return version ? version : false
                }
                return false
            },
            setExtCrump(){
                let color = this.resumeData?.configSelected?.dsgExt?.designation
                return color ? color : false
            },
            setIntCrump(){
                let color = this.resumeData?.configSelected?.dsgInt?.designation
                return color ? color : false
            },
        },
        methods: {
            ...mapMutations({
                resetNavSteps: 'navbarState/RESET_STEPS'
            }),
        }
    }
</script>
<style lang="scss">
    @import './ModelConfig.scss';
</style>
